import { useMutation } from "react-query";
import { useStoreCRMAnalyse } from "../stores/useStoreCRMAnalyse";
import { findDiffInCRMRecords } from "../apis/crm";

export const useCRMAnalyseRecords = ({ onSuccess, onError, onStream } = {}) => {
  const { addChunkInCRMBulkAnalyseData } = useStoreCRMAnalyse();

  return useMutation(
    ({ data, configId, options }) =>
      findDiffInCRMRecords({
        data,
        configId,
        options,
        onStream: (chunk) => {
          console.log("chunk analyse", chunk);

          // Internal store update
          addChunkInCRMBulkAnalyseData(chunk);
          // Custom consumer stream handler
          onStream?.(chunk);
        },
      }),
    {
      onSuccess: (data, variables, context) => {
        console.log("on success bulk analyse", data);
        // Internal post-success logic (if needed here)
        // Then user-provided callback
        onSuccess?.(data, variables, context);
      },
      onError: (error, variables, context) => {
        console.error("❌ Bulk analyse stream error:", error);
        onError?.(error, variables, context);
      },
    }
  );
};
